module.exports = __webpack_public_path__ + "img/house-chimney-user.6a1a5491.svg";